import { setWindowLocation } from 'js-utils/http';

export const handleRedirect = (url) => () => setWindowLocation(url);
